import React from "react";
// import { SocialIcon } from "react-social-icons";
import { useForm, SubmitHandler } from "react-hook-form";
import DOMPurify from "dompurify";

import EmailImg from "../../assets/images/ContactUs-Icon/Email.svg";
import LocImg from "../../assets/images/ContactUs-Icon/Location.svg";
import TelImg from "../../assets/images/ContactUs-Icon/Tel.svg";
import LinkedinImg from "../../assets/images/sosmed/IN.svg";
import WAImg from "../../assets/images/sosmed/WA.svg";
import { Homepage } from "../../@types/lang";
import Footer from "../Footer";

type Props = {
  lang: Homepage;
};

type Inputs = {
  name: string;
  email: string;
  message: string;
  subject: string;
};

const Contact = ({ lang }: Props) => {
  const { register, handleSubmit } = useForm<Inputs>();
  const onSubmit: SubmitHandler<Inputs> = (formData) => {
    window.location.href = `mailto:admin@omegasolusindo.co.id?subject=${formData.subject}&body=Hi, my name is ${formData.name}. ${formData.message} ${formData.email}`;
  };

  return (
    <div className="mx-2 lg:mx-8 rounded-[20px] relative bg-[#F9F9F9] flex flex-col lg:flex-row  lg:space-y-0 space-y-6 justify-center p-2 md:p-6 lg:space-x-10">
      <div className="flex flex-col space-y-5 py-6 w-full lg:w-[55%] mt-16">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex space-y-12 flex-col justify-center"
        >
          <div className="flex gap-6">
            <div className="flex flex-col gap-3 w-full">
              <label htmlFor="name" className="labelField">
                {lang.contact_name_label}
              </label>
              <input
                {...register("name")}
                type="text"
                id="name"
                name="name"
                className="inputField"
                required
              />
            </div>
            <div className="flex flex-col gap-3 w-full">
              <label htmlFor="email" className="labelField">
                {lang.contact_email_label}
              </label>
              <input
                {...register("email")}
                type="email"
                name="email"
                id="email"
                className="inputField"
                required
              />
            </div>
          </div>

          <div className="flex flex-col gap-3 w-full">
            <label htmlFor="subject" className="labelField">
              {lang.contact_subject_label}
            </label>
            <input
              {...register("subject")}
              type="text"
              name="subject"
              id="subject"
              className="inputField"
              required
            />
          </div>

          <div className="flex flex-col gap-3 w-full">
            <label htmlFor="pesan" className="labelField">
              {lang.contact_message_label}
            </label>
            <textarea
              {...register("message")}
              className="inputField"
              id="pesan"
              name="pesan"
            ></textarea>
          </div>

          <div className="flex items-center justify-between flex-col md:flex-row">
            <button
              className="bg-[#504E48] hover:bg-[#504E22] py-3 px-6 text-center text-white rounded-[10px] max-sm:w-full"
              type="submit"
            >
              {lang.contact_btn_form}
            </button>
            <Footer />
          </div>
        </form>
      </div>
      <div className="flex flex-col justify-center space-y-6 w-full lg:w-[45%] px-6 lg:px-10 py-14 lg:py-20 text-justify bg-[#504E48] rounded-[20px]">
        <h3 className="text-white text-[30px] font-semibold">
          {lang.contact_title}
        </h3>
        <p
          className="text-sm lg:text-lg text-white"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(lang.contact_text),
          }}
        ></p>
        <div className="flex flex-col space-y-4 justify-center">
          <div className="flex items-center space-x-5">
            <img className="fill-[#81B465]" src={EmailImg} alt="email" />
            <p className="text-sm lg:text-lg text-white">
              marketing@omegasolusindo.co.id
            </p>
          </div>
          <div className="flex items-center space-x-5">
            <img className="fill-[#81B465]" src={TelImg} alt="Telephone" />
            <p className="text-sm lg:text-lg text-white">+62 21 213384301</p>
          </div>
          <div className="flex items-center space-x-5">
            <img className="fill-[#81B465]" src={LocImg} alt="location" />
            <p className="text-sm lg:text-lg text-white w-4/6">
              Kawasan Niaga Citra Gran Blok R7 No.16, Jatisampurna, Kota Bekasi
              17435 Indonesia
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-3 md:space-x-5 text-white">
          <p className="text-sm md:text-xl max-sm:text-center">
            Our Social Media
          </p>
          <div className="w-[30px] h-[2px] bg-white"></div>
          {/* Social Media */}
          <a
            href="https://wa.me/6281333347484"
            target="_blank"
            rel="noreferrer"
            className="w-12 h-12 rounded-full"
          >
            <img src={WAImg} alt="whatsapp" className="w-12 h-12" />
          </a>
          <a
            href="https://www.linkedin.com/in/pt-omega-solusindo-bersama-20294629b/"
            target="_blank"
            rel="noreferrer"
            className="w-12 h-12"
          >
            <img src={LinkedinImg} alt="linkedin" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
